import React, { useEffect, useState } from "react";
import { Panel } from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Loadable from "react-loading-overlay";
import { useParams } from "react-router";
import EditModal from "../Contacts/EditContactModal";
import Field from "../Shared/Field";
import HistoryPanel from "../Shared/HistoryPanel";
import ContactsService from "../utils/ContactsService";
import CallRecordPanel from "../Voice/CallRecordPanel";
import { e164 } from "../Voice/e164";
import SmsRecordPanel from "../Voice/SmsRecordPanel";
import RelatedPanel from "./RelatedPanel";

const Show = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [contact, setContact] = useState();
  const [editContact, setEditContact] = useState();
  const [showModalEdit, setShowModalEdit] = useState();

  useEffect(() => {
    loadContact(id);
  }, [id]);

  const loadContact = async (id) => {
    setIsLoading(true);
    const contact = await ContactsService.get(id);
    setIsLoading(false);
    setContact(contact);
  };

  const handleConfirmModal = (response) => {
    setShowModalEdit(false);
    if (response.contact) setContact(response.contact);
  };

  if (!contact) return null;

  const contactUrl = contact.lm_contact_id
    ? `${process.env.REACT_APP_LEADMACHINE_URL}/app#!/contacts/${contact.lm_contact_id}`
    : "";
  const internationalNumber = e164(contact.mobile);
  const mcUrl = `${process.env.REACT_APP_LEADMACHINE_URL}/app#!/message_centre/messages/thread/${internationalNumber}`;

  return <div>
      <Loadable
        active={isLoading}
        spinner
        text=""
        color="#444"
        background="rgba(255, 255, 255, 0.5)"
      >
        {contact && (
          <div>
            <h3 className="first-title" style={{ marginBottom: 30 }}>
              Contact #{contact.id} : {contact.email || "<unknown email>"}{" "}
              <small>
                <button
                  className="button-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setEditContact(contact)
                    setShowModalEdit(true)
                  }}
                >
                  edit contact
                </button>
              </small>
            </h3>

            <div className="row" style={{ clear: "both" }}>
              <div className="col-md-6">
                <Panel bsStyle="success" className="compact-panel">
                  <Panel.Heading>
                    <Panel.Title componentClass="h3">
                      <div>Contact</div>
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <Field
                      label="Type"
                      value={contact.contact_type || "<unknown>"}
                    />
                    <Field
                      label="First Name"
                      value={contact.first_name || "<unknown>"}
                    />
                    <Field
                      label="Last Name"
                      value={contact.last_name || "<unknown>"}
                    />
                    <Field
                      label="Email"
                      value={contact.email || "<unknown email>"}
                    />
                    <Field
                      label="Mobile"
                      value={contact.mobile}
                      dialer={true}
                    />
                    {(contact.bad_number || contact.unsubscribed_number) && (
                      <Field label="">
                        {contact.bad_number && (
                          <span
                            style={{ marginRight: 4 }}
                            className="label label-danger"
                          >
                            BAD NUMBER
                          </span>
                        )}
                        {contact.unsubscribed_number && (
                          <span
                            style={{ marginRight: 4 }}
                            className="label label-warning"
                          >
                            UNSUBSCRIBED NUMBER
                          </span>
                        )}
                      </Field>
                    )}

                    <Field
                      label="LeadMachine Contact"
                      value={
                        contact.lm_contact_id ? (
                          <a href={contactUrl} target="lm">
                            open contact
                          </a>
                        ) : (
                          <span>not created yet</span>
                        )
                      }
                    />
                    <Field
                      label="LeadMachine SMS"
                      value={
                        <a href={mcUrl} target="lm">
                          search LeadMachine
                        </a>
                      }
                    />

                    <div style={{ marginTop: 20 }}>
                      <Field
                        label="Quick Notes"
                        value={contact.quicknotes}
                        blockDisplay
                      />
                    </div>
                  </Panel.Body>
                </Panel>
              </div>
              <div className="col-md-6">
                <RelatedPanel
                  deals={contact.related_deals}
                  followUps={contact.follow_ups}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <CallRecordPanel callRecords={contact.call_records} />
              </div>
              <div className="col-sm-6">
                <SmsRecordPanel smsRecords={contact.sms_records} />
              </div>
            </div>

            {contact && contact.history && contact.history.lines.length > 0 && (
              <Panel bsStyle="success" className="compact-panel">
                <Panel.Heading>
                  <Panel.Title componentClass="h3">History</Panel.Title>
                </Panel.Heading>
                <Panel.Body style={{ padding: 3 }}>
                  <HistoryPanel history={contact.history} />
                </Panel.Body>
              </Panel>
            )}
          </div>
        )}
      </Loadable>

      <EditModal
        showModal={showModalEdit}
        contact={editContact}
        onConfirmModal={handleConfirmModal}
        onCloseModal={() => setShowModalEdit(false)}
      />
    </div>
};

export default Show
